export function generateId () : string {
  const seeds = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let res = ''
  for (let i = 0; i < 8; i++) {
    res += seeds.charAt(Math.floor(Math.random() * seeds.length))
  }
  return res
}

export function convertNumberToMoneyFormat (value : number | undefined | null) : string {
  if (value === undefined || value === null) return ''
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
